import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarcode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBarcode"><Path d="M7.25 4.75H5.75C4.09315 4.75 2.75 6.09315 2.75 7.75V9.25M16.75 4.75H18.25C19.9069 4.75 21.25 6.09315 21.25 7.75V9.25M21.25 14.75V16.25C21.25 17.9069 19.9069 19.25 18.25 19.25H16.75M7.25 19.25H5.75C4.09315 19.25 2.75 17.9069 2.75 16.25V14.75M7.75 9.75V14.25M16.25 9.75V14.25M12 9.75V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBarcode;
